<template>
	<div>
		<div class="dl-container" v-loading="homeLoading">
			<main-header class="i-h" :child="child"></main-header>
			<div style="padding: 20px 0 0 20px;">
				<el-button type="success" @click="exportExcel(key)">导出excel</el-button>
			</div>
			<div class="list-group">
				<div class="list-item" v-for="(val,key) in list" :key="key">
					<div class="list-header flex-cb">
						<div>{{key}}<span style="color: red;font-size: 14px;margin-left: 5px;"
								v-if="val[0].sort && val[0].sort > 0">(已抽签)</span></div>
						<div>
							<!-- <el-button type="success" plain @click="exportExcel(key)">导出excel</el-button> -->
							<el-button type="primary" @click="handleclick(key,val)">进入抽签</el-button>
						</div>
					</div>
					<div class="list-con">
						<div class="list-cell col-center" v-for="(item,index) in val" :key="index">
							<!-- <div class="number">{{index+1}}</div> -->
							<div>{{item.name}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog :title="objKey" :visible.sync="dialogVisible" top="0vh" width="80vw" :before-close="handleClose">
			<div v-loading="loading">
				<div class="sort-container">
					<div class="sort-data-item"
						:style="{...styleArray[index].style,transition:'all '+(objArray.length < 10 ? '.2' : '.3') +'s'}"
						v-for="(item,index) in objArray" :key="index">
						<div class="sort-data-text">
							{{item.name}}
						</div>
						<div class="sort-data-badge" v-if="!isSort">
							<el-badge :value="styleArray[index].index + 1" class="item" type="success"></el-badge>
						</div>

					</div>
				</div>
				<div class="col-center sort-btn-group">
					<div class="sort-btn-item">
						<el-button type="primary" @click="start">开始抽签</el-button>
					</div>
					<div class="sort-btn-item">
						<el-button type="warning" plain @click="stop">停止抽签</el-button>
					</div>
					<div class="sort-btn-item">
						<el-button type="success" @click="exportExcel(objKey)">导出excel</el-button>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<!-- <el-button type="primary" @click="dialogVisible = false">确 定</el-button> -->
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import mainHeader from '@/components/main-header/main-header'
	import {
		getList,
		getSortResult,
		exportSortResult
	} from '@/common/api/sort.js'
	export default {
		name: '',
		props: {

		},
		components: {
			mainHeader
		},
		data() {
			return {
				child: [],
				list: {},
				objArray: [],
				objKey: '',
				dialogVisible: false,
				styleArray: [],
				indexArray: [],
				timer: null,
				isSort: false,
				resultData: [],
				loading: false,
				homeLoading: false,
			}
		},
		created() {
			this.getList()
		},
		mounted() {
			// 添加面包屑
			this.child = [{
				path: "/index",
				name: "Index",
				title: this.authority === 'expert' ? '参赛作品评审' : '首页'
			}]
		},
		beforeDestroy() {
			window.clearInterval(this.timer)
		},
		methods: {
			handleClose() {
				window.clearInterval(this.timer)
				this.dialogVisible = false
			},
			async getList() {
				this.homeLoading = true
				const {
					data
				} = await getList()
				console.log(data)
				this.list = data
				this.homeLoading = false
			},
			sortInterVal() {
				this.indexArray.sort(() => Math.random() - 0.5)
				this.styleArray = []
				this.indexArray.forEach((val, index) => {
					this.styleArray.push({
						index: val,
						style: {
							top: Math.floor(val / 3) * 49 + (Math.floor(val / 3) + 1) * 10 + 'px',
							left: (val % 3) * 492 + (val % 3 + 1) * 10 + 'px'
						},
					})
				})
			},
			async start() {
				if (this.isSort) {
					return
				}
				this.loading = true
				const {
					data
				} = await getSortResult({
					group_name: this.objKey
				})
				this.loading = false
				this.resultData = data
				this.isSort = true
				this.timer = window.setInterval(() => {
					this.sortInterVal()
				}, this.objArray.length < 10 ? 200 : 300)
			},
			stop() {
				this.isSort = false
				window.clearInterval(this.timer)
				this.objArray = this.resultData
				this.styleArray = []
				this.indexArray = []
				this.objArray.forEach((item, index) => {
					this.styleArray.push({
						index,
						style: {
							top: Math.floor(index / 3) * 49 + (Math.floor(index / 3) + 1) * 10 + 'px',
							left: (index % 3) * 492 + (index % 3 + 1) * 10 + 'px'
						}
					})
					this.indexArray.push(index)
				})
				this.getList()
			},
			handleclick(key, val) {
				this.objKey = key
				this.objArray = val
				this.styleArray = []
				this.indexArray = []
				val.forEach((item, index) => {
					this.styleArray.push({
						index,
						style: {
							top: Math.floor(index / 3) * 49 + (Math.floor(index / 3) + 1) * 10 + 'px',
							left: (index % 3) * 492 + (index % 3 + 1) * 10 + 'px'
						}
					})
					this.indexArray.push(index)
				})
				this.dialogVisible = true
			},
			async exportExcel(group_name) {
				this.homeLoading = true
				const {
					data
				} = await exportSortResult()
				this.homeLoading = false
				window.open(data.url)
			}
		}

	}
</script>

<style lang="scss" scoped>
	.dl-container {
		height: 100vh;
		display: flex;
		flex-direction: column;
		background-color: #f2f2f2f2;

		.list-group {
			padding: 20px;
			height: 0;
			flex-grow: 1;
			overflow-y: auto;
			display: flex;
			flex-wrap: wrap;

			& .list-item:nth-child(3n-1) {
				margin: 0 20px 20px;
			}

			.list-item {
				width: calc((100% - 40px) / 3);
				background-color: white;
				border-radius: 4px;
				margin-bottom: 20px;
				height: 335px;
				box-shadow: 0 0 5px rgba(0, 0, 0, .1);
				display: flex;
				flex-direction: column;

				.list-header {
					padding: 14px;
					border-bottom: 1px solid #e2e2e2;
				}

				.list-con {
					height: 0;
					flex-grow: 1;
					overflow-y: auto;

					// padding: 8px 16px;
					.list-cell {
						padding: 16px;

						.number {
							// border: 1px solid #4979ff;
							background-color: #4979ff;
							color: white;
							text-align: center;
							height: 20px;
							line-height: 20px;
							width: 20px;
							font-size: 12px;
							border-radius: 50%;
							margin-right: 10px;
						}
					}

					& .list-cell:nth-child(even) {
						background-color: #f4f4f4;
					}

					.list-cell:hover {
						background-color: #e9fafa;
					}
				}
			}
		}
	}

	::v-deep {
		.el-dialog__title {
			color: white;
		}

		.el-dialog__footer {
			display: none;
		}

		.el-dialog__close {
			color: white;
		}
	}

	.sort-container {
		width: 100%;
		height: 78vh;
		background-color: rgba(0, 0, 0, .05);
		display: flex;
		flex-wrap: wrap;
		align-items: flex-start;
		align-content: flex-start;
		border-radius: 4px;
		padding: 10px;
		position: relative;
		overflow-y: auto;
		overflow-x: hidden;

		.sort-data-item {
			padding: 14px;
			width: 460px;
			border: 1px solid #8a9cff;
			background-color: #fff;
			color: #4979ff;
			// margin: 5px;
			border-radius: 4px;
			position: absolute;
			transition: all .3s;

			.sort-data-text {
				width: 100%;
				white-space: nowrap;
				text-overflow: ellipsis;
				overflow: hidden;
				user-select: none;
			}

			.sort-data-badge {
				position: absolute;
				left: -10px;
				top: -10px;
			}
		}
	}

	.sort-btn-group {
		display: flex;
		padding-top: 20px;
		justify-content: center;

		.sort-btn-item {
			padding: 0 20px;
		}
	}
</style>